module.exports = __webpack_public_path__ + "img/pp-09.67408a26.jpg";